"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactLifecyclesCompat = require("react-lifecycles-compat");
var _classnames = _interopRequireDefault(require("classnames"));
var _ExpandableList = _interopRequireDefault(require("./ExpandableList"));
var _List = _interopRequireDefault(require("./List"));
var _TextInputLabel = _interopRequireDefault(require("./TextInputLabel"));
var _Ellipsis = _interopRequireDefault(require("./Ellipsis"));
var _Divider = _interopRequireDefault(require("./Divider"));
var _WithError = _interopRequireDefault(require("./WithError"));
var _reduxForm = require("./utility/redux-form");
var _focus = require("./utility/focus");
var _dom = require("./utility/dom");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
// `PureComponent` is only available in React >= 15.3.0.
var PureComponent = _react["default"].PureComponent || _react["default"].Component;
var empty_value_option_value = '';
var Select = /*#__PURE__*/function (_PureComponent) {
  _inherits(Select, _PureComponent);
  var _super = _createSuper(Select);
  function Select() {
    var _this;
    _classCallCheck(this, Select);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {});
    _defineProperty(_assertThisInitialized(_this), "focus", function () {
      return _this.select.focus();
    });
    // On mobile devices the <button/> is focused instead of <select/>
    // because when <select/> is focused then native mobile <select/> is expanded.
    _defineProperty(_assertThisInitialized(_this), "focusToggler", function () {
      return _this.selectButton.focus();
    });
    _defineProperty(_assertThisInitialized(_this), "onCollapse", function (_ref) {
      var focusOut = _ref.focusOut;
      _this.setState({
        isExpanded: false
      });
      if (!focusOut) {
        if (_this.isUsingKeyboard) {
          _this.focus();
        } else {
          _this.focusToggler();
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onExpand", function () {
      return _this.setState({
        isExpanded: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "expand", function () {
      return _this.list.expand();
    });
    _defineProperty(_assertThisInitialized(_this), "collapse", function () {
      return _this.list.collapse();
    });
    _defineProperty(_assertThisInitialized(_this), "toggle", function () {
      return _this.list.toggle();
    });
    _defineProperty(_assertThisInitialized(_this), "storeListRef", function (ref) {
      return _this.list = ref;
    });
    _defineProperty(_assertThisInitialized(_this), "storeSelectNode", function (node) {
      return _this.select = node;
    });
    _defineProperty(_assertThisInitialized(_this), "storeSelectButton", function (node) {
      return _this.selectButton = node;
    });
    _defineProperty(_assertThisInitialized(_this), "storeInputComponentNode", function (node) {
      return _this.inputComponentNode = node;
    });
    _defineProperty(_assertThisInitialized(_this), "storeContainerNode", function (node) {
      return _this.container = node;
    });
    _defineProperty(_assertThisInitialized(_this), "getSelectButton", function () {
      return _this.selectButton;
    });
    _defineProperty(_assertThisInitialized(_this), "nativeSelectOnKeyDown", function (event) {
      _this.isUsingKeyboard = true;
      if (_this.shouldShowOptionsList()) {
        // Native select is the main focusable element now
        // even when the custom select is rendered.
        // this.focusToggler()
        _this.onKeyDownFromNativeSelect = true;
        _this.onKeyDown(event);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "nativeSelectOnMouseDown", function (event) {
      if (_this.shouldShowOptionsList()) {
        event.preventDefault();
        // Native select is the main focusable element now
        // even when the custom select is rendered.
        // this.focusToggler()
        _this.toggle();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "nativeSelectOnChange", function (event) {
      var _this$props = _this.props,
        _native = _this$props["native"],
        nativeExpanded = _this$props.nativeExpanded;
      var value = event.target.value;

      // Convert back from an empty string to `undefined`
      if (value === empty_value_option_value) {
        // `null` is not accounted for, use `undefined` instead.
        value = undefined;
      }
      _this.setValue(value);

      // Firefox has a bug:
      // Spacebar key on native `<select/>` is not being "preventDefault"ed.
      // https://bugzilla.mozilla.org/show_bug.cgi?id=1428992
      // https://bugzilla.mozilla.org/show_bug.cgi?id=1019630
      // https://stackoverflow.com/questions/15141398/cannot-preventdefault-via-firefox-on-a-select
      // This workaround hides the custom `<Select/>`
      // when a user selects something in the native `<select/>`
      // which expands over the custom one in Firefox due to the bug.
      if (navigator.userAgent.toLowerCase().indexOf('firefox') >= 0) {
        if (!_native && !nativeExpanded) {
          _this.collapse();
        }
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onClick", function (event) {
      var _this$props2 = _this.props,
        disabled = _this$props2.disabled,
        nativeExpanded = _this$props2.nativeExpanded;
      if (!disabled) {
        _this.toggle();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event) {
      var _this$props3 = _this.props,
        disabled = _this$props3.disabled,
        value = _this$props3.value,
        required = _this$props3.required;
      var isExpanded = _this.state.isExpanded;

      // Reset "event came from native select" flag.
      var fromNativeSelect = _this.onKeyDownFromNativeSelect;
      _this.onKeyDownFromNativeSelect = false;
      if (disabled) {
        return;
      }
      if (event.defaultPrevented) {
        return;
      }
      if (!isExpanded) {
        if ((0, _dom.submitFormOnCtrlEnter)(event, _this.selectButton)) {
          return;
        }
      }
      if (event.ctrlKey || event.altKey || event.shiftKey || event.metaKey) {
        return;
      }
      switch (event.keyCode) {
        // "Up" arrow.
        // Select the previous item (if present).
        case 38:
        // "Down" arrow.
        // Select the next item (if present).
        case 40:
          // Firefox has a bug:
          // Up/Down arrow keys on native `<select/>` are not being "preventDefault"ed.
          // https://bugzilla.mozilla.org/show_bug.cgi?id=1428992
          // https://bugzilla.mozilla.org/show_bug.cgi?id=1019630
          // https://stackoverflow.com/questions/15141398/cannot-preventdefault-via-firefox-on-a-select
          // This workaround doesn't expand the custom `<Select/>`
          // when a user presses an Up/Down arrow key on the native `<select/>`.
          if (navigator.userAgent.toLowerCase().indexOf('firefox') >= 0) {
            return;
          }
          return _this.list.onKeyDown(event);

        // "Enter".
        case 13:
          // Submit containing `<form/>`.
          // Expand otherwise.
          if (required && isEmptyValue(value) || !(0, _dom.submitContainingForm)(_this.selectButton)) {
            _this.expand();
          }
          return event.preventDefault();

        // "Spacebar".
        case 32:
          if (fromNativeSelect) {
            // Firefox has a bug:
            // Spacebar key on native `<select/>` is not being "preventDefault"ed.
            // https://bugzilla.mozilla.org/show_bug.cgi?id=1428992
            // https://bugzilla.mozilla.org/show_bug.cgi?id=1019630
            // https://stackoverflow.com/questions/15141398/cannot-preventdefault-via-firefox-on-a-select
            event.preventDefault();
            _this.expand();
          }
          return;
      }
    });
    _defineProperty(_assertThisInitialized(_this), "setValue", function (newValue) {
      var _this$props4 = _this.props,
        value = _this$props4.value,
        onChange = _this$props4.onChange;

      // Call `onChange` only if the `value` did change.
      if (newValue !== value) {
        onChange(newValue);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onBlur", function (event) {
      clearTimeout(_this.blurTimer);
      var result = (0, _focus.onBlur)(event, _this.onFocusOut, function () {
        return _this.container;
      });
      if (typeof result === 'number') {
        _this.blurTimer = result;
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onFocusOut", function (event) {
      var _this$props5 = _this.props,
        _native2 = _this$props5["native"],
        nativeExpanded = _this$props5.nativeExpanded,
        onBlur = _this$props5.onBlur,
        value = _this$props5.value;
      if (!_native2 && !nativeExpanded) {
        // `window.rruiCollapseOnFocusOut` can be used
        // for debugging expandable contents.
        if (window.rruiCollapseOnFocusOut !== false) {
          _this.collapse();
        }
      }

      // // Collapse the options `<List/>` if it's expanded.
      // if (this.list) {
      // 	this.list.onBlur(event)
      // }

      _this._onFocusOut();
      if (onBlur) {
        (0, _reduxForm.onBlurForReduxForm)(onBlur, event, value);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onFocusIn", function () {
      return _this.setState({
        isFocused: true
      });
    });
    _defineProperty(_assertThisInitialized(_this), "_onFocusOut", function () {
      return _this.setState({
        isFocused: false
      });
    });
    return _this;
  }
  _createClass(Select, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.blurTimer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props6 = this.props,
        upward = _this$props6.upward,
        icon = _this$props6.icon,
        compact = _this$props6.compact,
        scroll = _this$props6.scroll,
        scrollMaxItems = _this$props6.scrollMaxItems,
        scrollIntoView = _this$props6.scrollIntoView,
        alignment = _this$props6.alignment,
        saveOnIcons = _this$props6.saveOnIcons,
        _native3 = _this$props6["native"],
        disabled = _this$props6.disabled,
        required = _this$props6.required,
        placeholder = _this$props6.placeholder,
        options = _this$props6.options,
        value = _this$props6.value,
        onChange = _this$props6.onChange,
        showErrorMessage = _this$props6.showErrorMessage,
        error = _this$props6.error,
        closeButtonIcon = _this$props6.closeButtonIcon,
        closeLabel = _this$props6.closeLabel,
        optionComponent = _this$props6.optionComponent,
        selectedOptionComponent = _this$props6.selectedOptionComponent,
        ScrollableContainer = _this$props6.ScrollableContainer,
        getScrollableContainerHeight = _this$props6.getScrollableContainerHeight,
        getScrollableContainerScrollY = _this$props6.getScrollableContainerScrollY,
        setScrollableContainerScrollY = _this$props6.setScrollableContainerScrollY,
        wait = _this$props6.wait,
        style = _this$props6.style,
        className = _this$props6.className;
      var _this$state = this.state,
        isExpanded = _this$state.isExpanded,
        isFocused = _this$state.isFocused;
      var topLabel = this.getTopLabel();
      return /*#__PURE__*/_react["default"].createElement(_WithError["default"], {
        setRef: this.storeContainerNode,
        error: showErrorMessage ? error : undefined,
        style: style,
        className: (0, _classnames["default"])(className, 'rrui__select', {
          'rrui__select--empty': isEmptyValue(value),
          'rrui__select--compact': compact || icon,
          'rrui__select--focus': isFocused
        })
      }, /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.storeInputComponentNode,
        style: selectedOptionComponent && DISPLAY_FLEX,
        className: selectedOptionComponent ? undefined : 'rrui__input'
      }, wait && /*#__PURE__*/_react["default"].createElement(_Ellipsis["default"], null), this.renderNativeSelect(), !_native3 && this.renderSelectButton(), topLabel && /*#__PURE__*/_react["default"].createElement(_TextInputLabel["default"], {
        "aria-hidden": true,
        value: value,
        required: required,
        invalid: error,
        floats: false
      }, topLabel), this.shouldShowOptionsList() && /*#__PURE__*/_react["default"].createElement(_ExpandableList["default"], {
        ref: this.storeListRef,
        "aria-label": this.getAriaLabel(),
        "aria-labelledby": this.props['aria-labelledby'],
        "aria-describedby": this.props['aria-describedby'],
        "aria-required": this.getAriaRequired(),
        "aria-invalid": this.getAriaInvalid(),
        upward: upward,
        alignment: alignment,
        scrollIntoView: scrollIntoView,
        scrollMaxItems: scroll === false ? 0 : scrollMaxItems,
        tabbable: false,
        value: value,
        onChange: this.setValue,
        onCollapse: this.onCollapse,
        onExpand: this.onExpand,
        getTogglerNode: this.getSelectButton,
        onFocusIn: this.onFocusIn,
        onFocusOut: this.onFocusOut,
        ScrollableContainer: ScrollableContainer,
        getScrollableContainerHeight: getScrollableContainerHeight,
        getScrollableContainerScrollY: getScrollableContainerScrollY,
        setScrollableContainerScrollY: setScrollableContainerScrollY,
        closeButtonIcon: closeButtonIcon,
        closeLabel: closeLabel,
        className: (0, _classnames["default"])('rrui__shadow', 'rrui__options-list', {
          'rrui__options-list--left-aligned': alignment === 'left',
          'rrui__options-list--right-aligned': alignment === 'right'
        })
      }, options.map(function (option, i) {
        return /*#__PURE__*/_react["default"].createElement(_List["default"].Item, {
          key: i,
          value: option.value,
          icon: option.divider || saveOnIcons ? undefined : option.icon,
          component: option.divider ? undefined : optionComponent,
          item: option.divider ? undefined : optionComponent ? option : undefined
        }, option.divider ? /*#__PURE__*/_react["default"].createElement(_Divider["default"], null) : optionComponent ? undefined : option.content ? option.content(option) : option.label);
      }))));
    }
  }, {
    key: "renderSelectButton",
    value: function renderSelectButton() {
      var _this$props7 = this.props,
        wait = _this$props7.wait,
        value = _this$props7.value,
        disabled = _this$props7.disabled,
        required = _this$props7.required,
        icon = _this$props7.icon,
        title = _this$props7.title,
        _native4 = _this$props7["native"],
        nativeExpanded = _this$props7.nativeExpanded,
        toggleClassName = _this$props7.toggleClassName,
        selectedOptionClassName = _this$props7.selectedOptionClassName,
        selectedOptionInvalidClassName = _this$props7.selectedOptionInvalidClassName,
        selectedOptionDisabledClassName = _this$props7.selectedOptionDisabledClassName,
        error = _this$props7.error,
        SelectedOptionComponent = _this$props7.selectedOptionComponent,
        arrowComponent = _this$props7.arrowComponent;
      var isExpanded = this.state.isExpanded;
      var selected = this.getSelectedOption();
      var selectedOptionLabel = selected && selected.label || this.getPlaceholder();
      var showIconOnly = icon && selected && selected.icon;

      // ARIA (accessibility) roles info:
      // https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html
      //
      // `aria-haspopup`:
      // https://www.w3.org/TR/wai-aria-1.1/#aria-haspopup
      // WAI-ARIA 1.1 is not yet supported, so not using `aria-haspopup="listbox"`.

      // This button could be focusable in case of !native && !nativeExpanded.
      // In case of nativeExpanded if this button was focusable then the user would
      // tab to the button and press Spacebar key and there would be no way to
      // expand the native select so the keyboard user would be stuck.
      // Because of this, this button is never tabbable and native select always is.

      return /*#__PURE__*/_react["default"].createElement("button", {
        ref: this.storeSelectButton,
        type: "button",
        disabled: disabled,
        onClick: this.onClick,
        onKeyDown: this.onKeyDown,
        onFocus: this.onFocusIn,
        onBlur: this.onBlur,
        tabIndex: -1,
        title: title,
        "aria-hidden": true,
        "aria-label": this.getAriaLabel() || (showIconOnly ? selectedOptionLabel : undefined),
        "aria-labelledby": this.props['aria-labelledby'],
        "aria-describedby": this.props['aria-describedby'],
        "aria-expanded": isExpanded ? true : false,
        className: (0, _classnames["default"])('rrui__button-reset', 'rrui__outline', 'rrui__select__button', toggleClassName, selectedOptionClassName, selectedOptionInvalidClassName && SelectedOptionComponent && error, selectedOptionDisabledClassName && SelectedOptionComponent && disabled, {
          'rrui__input-element': !SelectedOptionComponent,
          'rrui__select__button--empty': !SelectedOptionComponent && isEmptyValue(value) && !this.hasEmptyOption(),
          'rrui__select__button--invalid': !SelectedOptionComponent && error,
          'rrui__select__button--disabled': !SelectedOptionComponent && disabled
        })
      }, SelectedOptionComponent ? /*#__PURE__*/_react["default"].createElement(SelectedOptionComponent, selected) : /*#__PURE__*/_react["default"].createElement(DefaultSelectedOptionComponent, {
        required: !this.getTopLabel() && required,
        indicateRequired: !this.getTopLabel() && required && isEmptyValue(value),
        value: value,
        label: selectedOptionLabel,
        icon: showIconOnly ? /*#__PURE__*/_react["default"].createElement(selected.icon, {
          value: value,
          label: selectedOptionLabel
        }) : undefined,
        arrowComponent: arrowComponent
      }));
    }
  }, {
    key: "renderNativeSelect",
    value: function renderNativeSelect() {
      var _this$props8 = this.props,
        id = _this$props8.id,
        name = _this$props8.name,
        value = _this$props8.value,
        label = _this$props8.label,
        disabled = _this$props8.disabled,
        required = _this$props8.required,
        _native5 = _this$props8["native"],
        nativeExpanded = _this$props8.nativeExpanded,
        error = _this$props8.error,
        tabIndex = _this$props8.tabIndex;
      return /*#__PURE__*/_react["default"].createElement("select", {
        ref: this.storeSelectNode,
        id: id,
        name: name,
        value: isEmptyValue(value) ? empty_value_option_value : value,
        disabled: disabled,
        onKeyDown: this.nativeSelectOnKeyDown,
        onMouseDown: this.nativeSelectOnMouseDown,
        onChange: this.nativeSelectOnChange,
        onFocus: this.onFocusIn,
        onBlur: this.onBlur,
        tabIndex: tabIndex,
        "aria-label": this.getAriaLabel(),
        "aria-labelledby": this.props['aria-labelledby'],
        "aria-describedby": this.props['aria-describedby'],
        "aria-required": this.getAriaRequired(),
        "aria-invalid": this.getAriaInvalid(),
        className: (0, _classnames["default"])(
        // `:focus` style is implemented via border color
        // so outline can be muted safely here.
        'rrui__outline', 'rrui__select__native', {
          'rrui__select__native--empty': isEmptyValue(value),
          'rrui__select__native--overlay': !_native5,
          'rrui__select__native--disabled': disabled,
          'rrui__select__native--invalid': error
        })
      }, this.renderNativeSelectOptions());
    }
  }, {
    key: "renderNativeSelectOptions",
    value: function renderNativeSelectOptions() {
      var _this2 = this;
      var _this$props9 = this.props,
        options = _this$props9.options,
        value = _this$props9.value,
        placeholder = _this$props9.placeholder;
      var empty_option_present = false;
      var rendered_options = options.map(function (option, i) {
        var value = option.value,
          label = option.label,
          divider = option.divider;
        if (!divider && isEmptyValue(value)) {
          empty_option_present = true;
          value = empty_value_option_value;
        }
        return _this2.renderNativeSelectOption(i, value, label, divider === true, divider);
      });
      if (isEmptyValue(value) && !empty_option_present) {
        rendered_options.unshift(this.renderNativeSelectOption(-1, undefined, placeholder, true));
      }
      return rendered_options;
    }
  }, {
    key: "renderNativeSelectOption",
    value: function renderNativeSelectOption(key, value, label, nonSelectable, isDivider) {
      return /*#__PURE__*/_react["default"].createElement("option", {
        key: key,
        value: isEmptyValue(value) ? '' : value,
        hidden: nonSelectable && !isDivider ? true : undefined,
        disabled: nonSelectable ? true : undefined,
        className: (0, _classnames["default"])('rrui__select__native-option', {
          'rrui__select__native-option--divider': isDivider
        })
      }, label);
    }
  }, {
    key: "hasEmptyOption",
    value: function hasEmptyOption() {
      var options = this.props.options;
      for (var _iterator = _createForOfIteratorHelperLoose(options), _step; !(_step = _iterator()).done;) {
        var option = _step.value;
        if (!option.divider && isEmptyValue(option.value)) {
          return true;
        }
      }
      return false;
    }
  }, {
    key: "getSelectedOption",
    value: function getSelectedOption() {
      var _this$props10 = this.props,
        options = _this$props10.options,
        value = _this$props10.value;
      for (var _iterator2 = _createForOfIteratorHelperLoose(options), _step2; !(_step2 = _iterator2()).done;) {
        var option = _step2.value;
        if (!option.divider && option.value === value) {
          return option;
        }
      }
    }
  }, {
    key: "getAriaLabel",
    value: function getAriaLabel() {
      var _this$props11 = this.props,
        ariaLabel = _this$props11.ariaLabel,
        label = _this$props11.label;
      return this.props['aria-label'] === undefined ? ariaLabel || label : this.props['aria-label'];
    }
  }, {
    key: "getAriaRequired",
    value: function getAriaRequired() {
      var _this$props12 = this.props,
        required = _this$props12.required,
        value = _this$props12.value;
      return this.props['aria-required'] === undefined ? required && isEmptyValue(value) ? true : undefined : this.props['aria-required'];
    }
  }, {
    key: "getAriaInvalid",
    value: function getAriaInvalid() {
      var error = this.props.error;
      return this.props['aria-invalid'] === undefined ? error ? true : undefined : this.props['aria-invalid'];
    }
  }, {
    key: "getTopLabel",
    value: function getTopLabel() {
      var _this$props13 = this.props,
        label = _this$props13.label,
        placeholder = _this$props13.placeholder,
        value = _this$props13.value;
      if (isEmptyValue(value) && !placeholder) {
        // Label will be shown in placeholder's place
        // so don't show it as a label to prevent duplication.
        return;
      }
      return label;
    }
  }, {
    key: "getPlaceholder",
    value: function getPlaceholder() {
      var _this$props14 = this.props,
        label = _this$props14.label,
        placeholder = _this$props14.placeholder,
        value = _this$props14.value;
      if (isEmptyValue(value)) {
        return placeholder || label;
      }
    }
  }, {
    key: "shouldShowOptionsList",
    value: function shouldShowOptionsList() {
      var _this$props15 = this.props,
        _native6 = _this$props15["native"],
        nativeExpanded = _this$props15.nativeExpanded;
      return !_native6 && !nativeExpanded;
    }
  }]);
  return Select;
}(PureComponent);
_defineProperty(Select, "propTypes", {
  // A list of selectable options
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    // Option value (may be `undefined`)
    value: _propTypes["default"].any,
    // Could restrict it to stringifiable types
    // but I guess this is not required
    // and one could even use `object`s as `value`s.
    // // Option value (may be `undefined`)
    // value : PropTypes.oneOfType([
    // 	PropTypes.string,
    // 	PropTypes.number,
    // 	PropTypes.bool
    // ]),
    // Option label (may be `undefined`)
    label: _propTypes["default"].string,
    // Option icon
    icon: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]),
    // (deprecated, use `optionComponent` instead)
    // Render custom content (a React component).
    // Receives `{ value, label }` properties.
    content: _propTypes["default"].func
  })).isRequired,
  // HTML `id` attribute for the `<select/>` element.
  id: _propTypes["default"].string,
  // HTML form input `name` attribute
  name: _propTypes["default"].string,
  // Label which is placed above the select
  label: _propTypes["default"].string,
  // Placeholder (like "Choose")
  placeholder: _propTypes["default"].string,
  // Selected option component.
  // (when `<Select/>` is not expanded).
  // Receives properties:
  // `{ ...option }` — All properties of the selected `option` such as `value`, `label`, etc. Each `option` must have a `value` and a `label` (`value` may be `undefined`).
  // `wait` — Passed through `wait` property of the `<Select/>` component. `<Autocomplete/>` renders a `<Select/>` internally and passes `wait={true}` when it's loading options.
  // Can only contain "inline" elements like `<span/>`,
  // not `<div/>`s, `<section/`>s, `<h1/>`s or `<p/>`s,
  // because `<button/>`s can't contain "block" elements.
  // `display: block` can still be set on `<span/>`s and other "inline" elements.
  selectedOptionComponent: _propTypes["default"].elementType,
  // Dropdown arrow component.
  arrowComponent: _propTypes["default"].elementType,
  // Option component.
  // (when `<Select/>` is expanded).
  // Receives properties:
  // * `{ ...option }` — All properties of an `option` such as `value`, `label`, etc. Each `option` must have a `value` and a `label` (`value` may be `undefined`).
  // * `selected: boolean` — If this option is selected.
  // * `focused: boolean` — If this option is focused.
  // * `disabled: boolean` — If this option is disabled. Seems to be not used for now.
  // Can only contain "inline" elements like `<span/>`,
  // not `<div/>`s, `<section/`>s, `<h1/>`s or `<p/>`s,
  // because `<button/>`s can't contain "block" elements.
  // `display: block` can still be set on `<span/>`s and other "inline" elements.
  optionComponent: _propTypes["default"].elementType,
  // Options list alignment.
  // Is "left" by default.
  alignment: _propTypes["default"].string,
  // Whether to use native `<select/>`
  "native": _propTypes["default"].bool,
  // Whether to use native `<select/>` when expanded
  nativeExpanded: _propTypes["default"].bool,
  // Show icon only for selected item,
  // and only if `icon` is `true`.
  saveOnIcons: _propTypes["default"].bool,
  // Disables this control
  disabled: _propTypes["default"].bool,
  // Set to `true` to mark the field as required
  required: _propTypes["default"].bool,
  // Indicates that the input is invalid.
  error: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].bool]),
  showErrorMessage: _propTypes["default"].bool,
  // Set to `true` to display the loading indicator
  wait: _propTypes["default"].bool,
  // Selected option value
  value: _propTypes["default"].any,
  // Is called when an option is selected
  onChange: _propTypes["default"].func,
  // Is called when the select is blurred.
  // This `onBlur` interceptor is a workaround for `redux-form`,
  // so that it gets the parsed `value` in its `onBlur` handler,
  // not the formatted text.
  onBlur: _propTypes["default"].func,
  // If `scroll` is `false`, then options list
  // is not limited in height.
  // Is `true` by default (scrollable).
  scroll: _propTypes["default"].bool,
  // Component CSS class
  className: _propTypes["default"].string,
  // `<button/>` toggler CSS class
  // (deprecated name, use `selectedOptionClassName` property name instead)
  toggleClassName: _propTypes["default"].string,
  // Selected option `<button/>` CSS class.
  selectedOptionClassName: _propTypes["default"].string,
  // Selected option `<button/>` CSS class when `error` property is passed.
  selectedOptionInvalidClassName: _propTypes["default"].string,
  // Selected option `<button/>` CSS class when `disabled` property is passed.
  selectedOptionDisabledClassName: _propTypes["default"].string,
  // CSS style object
  style: _propTypes["default"].object,
  // If this flag is set to `true`,
  // and `icon` is specified for a selected option,
  // then the selected option will be displayed
  // as icon only, without the label.
  icon: _propTypes["default"].bool,
  // If this flag is set to `true`,
  // then it makes `<Select/>` not stretch itself
  // to 100% width by making it `inline-block`.
  // Is set to `true` when `icon` is `true`
  // because it makes sense.
  compact: _propTypes["default"].bool,
  // HTML `tabindex` attribute
  tabIndex: _propTypes["default"].number,
  // `aria-label` for the `<Select/>`'s `<button/>`.
  // Deprecated, use `aria-label` instead.
  ariaLabel: _propTypes["default"].string,
  ScrollableContainer: _propTypes["default"].elementType,
  getScrollableContainerHeight: _propTypes["default"].func,
  getScrollableContainerScrollY: _propTypes["default"].func,
  setScrollableContainerScrollY: _propTypes["default"].func
});
_defineProperty(Select, "defaultProps", {
  "native": false,
  nativeExpanded: false,
  saveOnIcons: false,
  // Set to `true` to mark the field as required
  required: false,
  // Show `error` (if passed).
  showErrorMessage: true,
  // Set to `true` to display the loading indicator
  wait: false,
  // Will show scrollbar on overflow.
  scroll: true,
  alignment: 'left'
});
var _default = (0, _reactLifecyclesCompat.polyfill)(Select); // Using indexes instead for keys.
// // There can be an `undefined` value,
// // so just `{ value }` won't do here.
// function getOptionKey(value) {
// 	return isEmptyValue(value) ? '@@rrui/empty' : value
// }
exports["default"] = _default;
function isEmptyValue(value) {
  return value === null || value === undefined;
}
function DefaultSelectedOptionComponent(_ref2) {
  var value = _ref2.value,
    label = _ref2.label,
    icon = _ref2.icon,
    required = _ref2.required,
    indicateRequired = _ref2.indicateRequired,
    _ref2$arrowComponent = _ref2.arrowComponent,
    ArrowComponent = _ref2$arrowComponent === void 0 ? ArrowComponentDefault : _ref2$arrowComponent;
  // The `<span/>` wrapper is required for vertical centering.
  // http://stackoverflow.com/questions/35464067/flexbox-not-working-on-button-element-in-some-browsers
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: "rrui__select__selected-content"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: (0, _classnames["default"])('rrui__select__selected-label', 'rrui__text-line', {
      // Deprecated.
      // Use `.rrui__input-label--required` instead.
      'rrui__select__selected-label--required': indicateRequired,
      'rrui__input-label--required': indicateRequired,
      'rrui__input-label--required-field': required
    })
  }, icon || label), /*#__PURE__*/_react["default"].createElement(ArrowComponent, null));
}
DefaultSelectedOptionComponent.propTypes = {
  value: _propTypes["default"].any,
  label: _propTypes["default"].string,
  icon: _propTypes["default"].node,
  required: _propTypes["default"].bool,
  indicateRequired: _propTypes["default"].bool,
  arrowComponent: _propTypes["default"].elementType
};
function ArrowComponentDefault() {
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: "rrui__select__arrow"
  });
}

/* `display: flex` fixes the incorrect toggler `<button/>` height
   in cases when custom `selectedOptionComponent` is used.
   It also removes the requirement for the `selectedOptionComponent`
   containing `<span/>` to be `display: block`. */
var DISPLAY_FLEX = {
  display: 'flex'
};
//# sourceMappingURL=Select.js.map